import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect, useReducer } from "react";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import en from "../../../lang/en-us";
import { CustomRadio } from "../../../lib/CustomRadio";
import TextInput from "../../../lib/TextField";
import {
  getFatcaDetails,
  getCountries,
  updateFATCA,
} from "../../../store/actions/nct";
import { RootStateType } from "../../../store/reducers/index";
import TaxDetail from "./TaxDetail";
import { IsAllow } from "../../../store/types/portfolio";
import {
  checkForOnlyAlphabets,
  FATCA,
  getDateString,
  OTP_ACTIONS,
} from "../../../utils/constants";
import KycFields from "./KycFields";
import {
  kycValidationSchema,
  kycValuesType,
  MAX_LENGTHS,
  prepareKycValidations,
} from "./utils";
import { isError, showHelperText } from "../../../utils/utilityFunctions";
import { BackArrow } from "../UpdateNominee/SelectedFolios";

const { dashboard, common, dbCommercial } = en;

type COUNTRY_DETAILS = {
  code: string;
  dial_code: string;
  name: string;
};

type COUNTRIES = {
  countries: COUNTRY_DETAILS[];
};

const payloadStaticValues = {
  folio: "",
  aadhaarNo: "",
  amc: "",
  sourceOfFunds: "",
  corporateServices: "",
  taxStatus: "",
};

const initialState = {
  isIndianResident: "",
  tinAvailability: false,
  identityVerification: "",
  reasonOption: "",
  countryOfBirth: "",
  nationality: "",
  taxResidency: "",
  identityVerificationText: "",
  tinId: "",
  declaration: "",
  reasonOptionText: "",
  remarks: "",
  placeOfBirth: "",
};

const kycInitialValues: kycValuesType = {
  occupation: "",
  pepFlag: "",
  fatherName: "",
  spouseName: "",
  netWorthDate: new Date(),
  annualIncomeSlab: "",
  placeOfBirth: "",
  addressType: "",
  netWorth: "",
  sourceOfWealth: "",
};

const taxInitialState = [
  {
    taxResidency: "",
    tinId: "",
    identityVerification: "",
    identityVerificationText: "",
    tinAvailability: false,
    editing: true,
    errPresent: false,
    reasonOption: "",
    reasonOptionText: "",
    errors: {},
  },
];
export const taxReducer = (state: any, action: any) => {
  switch (action.type) {
    case "INITIALIZE":
      return [...action.payload];
    case "CHANGE":
      const newState = [
        ...state.slice(0, action.payload.index),
        {
          ...state[action.payload.index],
          [action.payload.key]: action.payload.value,
        },
        ...state.slice(action.payload.index + 1),
      ];
      return newState;
    case "ADD":
      return [...state, ...taxInitialState];
    case "DELETE":
      return [
        ...state.slice(0, action.payload.index),
        ...state.slice(action.payload.index + 1),
      ];
    default:
      return state;
  }
};

function FatcaDeclaration(props: any) {
  const [state, setState] = useState<any>(initialState);
  const [isChecked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const kycFormik = useFormik({
    initialValues: kycInitialValues,
    onSubmit: () => {},
    validationSchema: kycValidationSchema(state.isIndianResident),
    validateOnMount: false,
  });
  const [taxData, taxDispatch] = useReducer(taxReducer, taxInitialState);
  const [errors, setErrors] = useState<any>({});

  const [countries, setCountries] = useState<COUNTRY_DETAILS[]>([]);
  const dispatch = useDispatch();
  useEffect(() => {
    async function callApi() {
      const payload: any = {
        pan: props.investorData.PAN,
        mobile: props.mobile,
        pekrn: props.investorData.PEKRN || "",
      };
      try {
        setLoading(true);
        const countriesData = await props.getCountries();
        const { countries: masterData = [] }: COUNTRIES = countriesData;
        setCountries(masterData);
        const { response: fatcaInfo } = await props.getFatcaDetails(payload);
        const { data: fatcaDetails = [], errors = [] } = fatcaInfo;
        if (errors.length && fatcaDetails.length === 0) {
          const [firstError] = errors;
          throw Error(firstError.message);
        }
        const data = fatcaDetails[0] || [];
        setState({
          ...state,
          isIndianResident: data?.taxResidencyOtherthanIndia,
          nationality: data?.nationality,
          countryOfBirth:
            (data?.taxResidencyOtherthanIndia || data?.declaration) ===
            IsAllow.No
              ? "India"
              : data?.countryOfBirth,
          placeOfBirth: data?.placeOfBirth,
        });

        const kycDetailsValues: kycValuesType = {
          netWorth: data?.netWorth,
          addressType: data?.addressType,
          placeOfBirth: data?.placeOfBirth,
          occupation: data?.occupation,
          annualIncomeSlab: data?.annualIncomeSlab,
          sourceOfWealth: data?.sourceOfWealth,
          fatherName: data?.fatherName,
          spouseName: data?.spouseName,
          pepFlag: data?.pepFlag,
          netWorthDate: data?.netWorthDate,
        };
        const kycDetailsInitValues = prepareKycValidations(kycDetailsValues);
        kycFormik.setValues(kycDetailsInitValues);
        const taxDetails = data?.taxDetails || [];
        const _taxDetails = taxDetails.map((taxDetail: any) => ({
          taxResidency: taxDetail.countryTax,
          tinId: taxDetail.taxId,
          identityVerification:
            taxDetail.idType?.toLowerCase() === "tin"
              ? "tin"
              : "other-identity",
          identityVerificationText:
            taxDetail.idType?.toLowerCase() === "tin" ? "" : taxDetail.idType,
          tinAvailability: !taxDetail.taxId,
          reasonOptioN: !!taxDetail.tinReason
            ? getTinReasonOption(taxDetail.tinReason)
            : getTinReasonOption(taxDetail.remarks),
          reasonOptionText: !!taxDetail.tinReason
            ? getTinReasonOption(taxDetail.tinReason)
            : getTinReasonOption(taxDetail.remarks) === "C"
            ? taxDetail.remarks
            : "",
          editing: false,
          errPresent: false,
          errors: {},
        }));
        _taxDetails.length !== 0 &&
          taxDispatch({ type: "INITIALIZE", payload: _taxDetails });
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        alert(err.message);
      }
    }
    callApi();
    return () => {
      setCountries([]);
    };
  }, []);

  const validateTaxDetail = (taxDetail: any, index: number) => {
    let errors: any = {};
    let formIsValid = true;
    if (!state.isIndianResident) {
      formIsValid = false;
      errors["isIndianResident"] =
        dashboard.FatcaDeclaration.errors.taxResidency;
    }
    if (state.isIndianResident === "Y") {
      if (!taxDetail.taxResidency || taxDetail.taxResidency === "0") {
        formIsValid = false;
        errors["taxResidency"] =
          dashboard.FatcaDeclaration.errors.countryOfTaxResidency;
      }
      if (!taxDetail.tinAvailability) {
        if (!taxDetail.tinId) {
          formIsValid = false;
          errors["tinId"] = dashboard.FatcaDeclaration.errors.tinNumber;
        }
        if (!taxDetail.identityVerification) {
          formIsValid = false;
          errors["identityVerification"] =
            dashboard.FatcaDeclaration.errors.identificationType;
        }
        if (
          taxDetail.identityVerification === "other-identity" &&
          !taxDetail.identityVerificationText
        ) {
          formIsValid = false;
          errors["identityVerificationText"] =
            dashboard.FatcaDeclaration.errors.identificationReason;
        }
      } else {
        if (!taxDetail.reasonOption) {
          formIsValid = false;
          errors["reasonOption"] =
            dashboard.FatcaDeclaration.errors.noTinReason;
        }
        if (taxDetail.reasonOption === "C" && !taxDetail.reasonOptionText) {
          formIsValid = false;
          errors["reasonOptionText"] =
            dashboard.FatcaDeclaration.errors.noTinReason;
        }
        if (!checkMaxCharacter(state.reasonOptionText)) {
          formIsValid = false;
          errors["reasonOptionText"] =
            dashboard.FatcaDeclaration.errors.maxCharacterForTinReason;
        }
      }
    }
    if (!formIsValid) {
      taxDispatch({
        type: "CHANGE",
        payload: { index: index, value: true, key: "errPresent" },
      });
    }
    taxDispatch({
      type: "CHANGE",
      payload: { index: index, value: errors, key: "errors" },
    });
    return formIsValid;
  };

  const validateCommonFields = (state: any, isChecked: any) => {
    let errors: any = {};
    let formIsValid = true;
    if (!isChecked) {
      formIsValid = false;
      errors["isChecked"] = dashboard.FatcaDeclaration.errors.declarationBox;
    }
    if (!state.countryOfBirth || state.countryOfBirth === "0") {
      formIsValid = false;
      errors["countryOfBirth"] =
        dashboard.FatcaDeclaration.errors.countryOfBirth;
    }
    if (!state.nationality || state.nationality === "0") {
      formIsValid = false;
      errors["nationality"] = dashboard.FatcaDeclaration.errors.nationality;
    }
    setErrors(errors);
    return formIsValid;
  };
  const handleSubmit = async () => {
    const { mobile, pan, pekrn } = props;
    kycFormik.submitForm();
    let taxDetailsValid = true;
    const commonFieldsValid = validateCommonFields(state, isChecked);
    taxData.forEach(
      (taxDetail: any, index: number) =>
        (taxDetailsValid =
          taxDetailsValid && validateTaxDetail(taxDetail, index))
    );
    if (
      (commonFieldsValid && taxDetailsValid && kycFormik.isValid) ||
      (state.isIndianResident === IsAllow.No && isChecked && kycFormik.isValid)
    ) {
      try {
        let taxDetailsForAPI;
        if (state.isIndianResident === IsAllow.No) {
          taxDetailsForAPI = [
            {
              country: "",
              idType: "",
              taxId: "",
              tinReason: "",
              tinRemarks: "",
            },
          ];
        } else {
          taxDetailsForAPI = taxData.map((taxDetail: any) => {
            return {
              country: taxDetail.taxResidency,
              idType:
                taxDetail.identityVerification === "tin"
                  ? "TIN"
                  : taxDetail.identityVerificationText,
              taxId: taxDetail.tinId,
              tinReason: !!taxDetail.reasonOption ? taxDetail.reasonOption : "",
              tinRemarks:
                taxDetail.reasonOption === "C"
                  ? taxDetail.reasonOptionText
                  : "",
            };
          });
        }
        let data = {
          declaration: state.isIndianResident,
          taxResidencyOtherthanIndia: state.isIndianResident,
          countryOfBirth: state.countryOfBirth,
          nationality: state.nationality,
          taxResidency: taxDetailsForAPI,
          ...kycFormik.values,
          netWorthDate: getDateString(kycFormik.values.netWorthDate),
        };
        const investorName = props.investorData.invname;
        const investorPan = props.investorData.PAN;
        const investor = props.investors.find(
          (item: any) =>
            item.Name.toLowerCase() === investorName.toLowerCase() ||
            item.Pan.toLowerCase() == investorPan.toLowerCase()
        );

        const payload: {
          email: string;
          mobile: string;
          pan: string;
          distributor_id: string;
          data: any;
        } = {
          email: investor.Email,
          mobile: investor.Mobile,
          pan: investorPan,
          distributor_id: props.token,
          data: [data],
        };
        setLoading(true);
        const apiRes = await updateFATCA(payload)(dispatch);
        if (apiRes.status === 201) {
          props.history.replace("/new-transaction/nct-type/success", {
            state: {
              succesMessage: apiRes.message,
            },
          });
        }
      } catch (err: any) {
        alert(err.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const getTinReasonOption = (value: string) => {
    switch ((value || "").trim().toLowerCase()) {
      case "A".toLowerCase():
      case dashboard.FatcaDeclaration.accountHolderLiable.trim().toLowerCase():
        return "A";
      case "B".toLowerCase():
      case dashboard.FatcaDeclaration.noTinRequired.trim().toLowerCase():
        return "B";
      default:
        return "C";
    }
  };

  const checkMaxCharacter = (value: string) => {
    return value.length <= 10 ? true : false;
  };

  return (
    <div className="update-nominee-main">
      <div className="maxWidth">
        <div className="curved-bg">
          <BackArrow history={props.history} />
          <h5 style={{ marginLeft: "10px" }}>Fatca Declaration</h5>
          <div className="curved-bg-content curved-bg-table-outer">
            <div className="curved-bg-content-inner">
              <div className="curved-bg-content-inner-top">
                <div className="fatca-top-content" style={{ borderBottom: 0 }}>
                  <div className="tax-resident">
                    <Grid item xs={12} sm={5}>
                      <div className="fatca-enter-pan">
                        <h6>
                          {dashboard.FatcaDeclaration.enterPanPekrnHeading}
                        </h6>
                        <TextInput
                          label={dashboard.FatcaDeclaration.enterPanPekrn}
                          variant="outlined"
                          value={
                            props.investorData.PAN || props.investorData.PEKRN
                          }
                          disabled
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    </Grid>
                    <CustomRadio
                      extraClass="fatca-tax-resident"
                      title={dashboard.FatcaDeclaration.taxResident}
                      name="tax-resident"
                      list={[
                        {
                          label: dashboard.FatcaDeclaration.yesTxt,
                          value: IsAllow.YES,
                        },
                        {
                          label: dashboard.FatcaDeclaration.noTxt,
                          value: IsAllow.No,
                        },
                      ]}
                      selectedValue={state.isIndianResident}
                      handleRadioChange={(value: string) => {
                        const { isIndianResident, ...rest } = errors;
                        setErrors(rest);
                        setState({
                          ...initialState,
                          isIndianResident: value,
                          countryOfBirth: "",
                        });
                        if (value === IsAllow.No) {
                          setState((prev: any) => ({
                            ...prev,
                            countryOfBirth: "India",
                          }));
                          const { countryOfBirth, ...rest } = errors;
                          setErrors(rest);
                        }
                      }}
                      error={!!errors.isIndianResident}
                      helperText={errors.isIndianResident}
                      isLoading={loading}
                    />
                  </div>
                  <Grid
                    container
                    spacing={1}
                    className="taxResident-birthplace"
                  >
                    {(state.isIndianResident === IsAllow.YES ||
                      state.isIndianResident === IsAllow.No) && (
                      <Grid item xs={12} sm={4} lg={4}>
                        <div className="fatca-enter-pan">
                          <FormControl
                            variant="outlined"
                            error={!!errors.countryOfBirth}
                          >
                            <Select
                              labelId="countryOfBirth"
                              id="countryOfBirth"
                              value={state.countryOfBirth || "0"}
                              onChange={({ target: { value } }) => {
                                setState((prevState: any) => {
                                  return {
                                    ...prevState,
                                    countryOfBirth: value,
                                  };
                                });
                              }}
                              disabled={state.isIndianResident === IsAllow.No}
                              onFocus={() => {
                                const { countryOfBirth, ...rest } = errors;
                                setErrors(rest);
                              }}
                            >
                              {state.isIndianResident === IsAllow.YES && (
                                <MenuItem value="0"> Country of Birth</MenuItem>
                              )}
                              {state.isIndianResident === IsAllow.No ? (
                                <MenuItem value="India"> India </MenuItem>
                              ) : (
                                countries.map((_ele: COUNTRY_DETAILS) => (
                                  <MenuItem value={_ele.name}>
                                    {_ele.name}
                                  </MenuItem>
                                ))
                              )}
                            </Select>
                            <FormHelperText className={"error"}>
                              {errors.countryOfBirth}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </Grid>
                    )}
                    {state.isIndianResident === IsAllow.YES && (
                      <Grid item xs={12} sm={4} lg={4}>
                        <div className="fatca-nationality">
                          <FormControl
                            variant="outlined"
                            error={!!errors.nationality}
                          >
                            <Select
                              labelId="nationality"
                              id="nationality"
                              value={state.nationality || "0"}
                              onChange={({ target: { value } }) =>
                                setState({
                                  ...state,
                                  nationality: value,
                                })
                              }
                              onFocus={() => {
                                const { nationality, ...rest } = errors;
                                setErrors(rest);
                              }}
                            >
                              <MenuItem value="0">
                                {dashboard.FatcaDeclaration.nationality}
                              </MenuItem>
                              {countries.map((_ele: COUNTRY_DETAILS) => (
                                <MenuItem value={_ele.name}>
                                  {_ele.name}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText className={"error"}>
                              {errors.nationality}
                            </FormHelperText>
                          </FormControl>
                        </div>
                      </Grid>
                    )}
                    {(state.isIndianResident === IsAllow.No ||
                      state.isIndianResident === IsAllow.YES) && (
                      <Grid
                        item
                        xs={12}
                        sm={5}
                        lg={12}
                        style={{ marginBottom: "20px" }}
                      >
                        <TextField
                          id="birth-place"
                          name="placeOfBirth"
                          variant="outlined"
                          helperText={showHelperText(kycFormik, "placeOfBirth")}
                          error={isError(kycFormik, "placeOfBirth")}
                          value={kycFormik.values.placeOfBirth}
                          onChange={(e) => {
                            if (
                              checkForOnlyAlphabets(e.target.value) &&
                              e.target.value.length <= MAX_LENGTHS.placeOfBirth
                            ) {
                              kycFormik.setFieldValue(
                                "placeOfBirth",
                                e.target.value
                              );
                            }
                          }}
                          onBlur={kycFormik.handleBlur}
                          label={
                            dashboard.FatcaDeclaration.kycFields.placeOfBirth
                          }
                        />
                      </Grid>
                    )}
                  </Grid>
                </div>
                {state.isIndianResident === IsAllow.YES &&
                  taxData.map((taxDetail: any, _index: number) => {
                    return (
                      <TaxDetail
                        taxDetail={taxDetail}
                        length={taxData.length}
                        index={_index}
                        taxDispatch={taxDispatch}
                        validateTaxDetail={validateTaxDetail}
                        countries={countries}
                        state={state}
                      />
                    );
                  })}
                {taxData.length < 3 && state.isIndianResident === IsAllow.YES && (
                  <div className="add-tax">
                    <p>{`You can add ${3 - taxData.length} more ID${
                      taxData.length == 2 ? "" : "'S"
                    }`}</p>
                    <a onClick={() => taxDispatch({ type: "ADD" })}>
                      {dbCommercial.newPurchase.rightMenu.fatcaEdit.addId}
                    </a>
                  </div>
                )}
                {(state.isIndianResident === IsAllow.No ||
                  state.isIndianResident === IsAllow.YES) && (
                  <KycFields kycFormik={kycFormik} />
                )}
              </div>
              <div className="curved-bg-content-inner-bottom fatca-bottom-content">
                <FormControl error={!!errors.isChecked}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="fatca-acknowledge"
                        checked={isChecked}
                        onChange={() => setChecked(!isChecked)}
                        onFocus={() => {
                          const { isChecked, ...rest } = errors;
                          setErrors(rest);
                        }}
                        disabled={loading}
                      />
                    }
                    label={<>{dashboard.FatcaDeclaration.acknowledge} </>}
                  />
                  <FormHelperText>{errors.isChecked}</FormHelperText>
                </FormControl>
                <Button
                  //  href="/portal/nct/fatca-declaration-otp"
                  onClick={handleSubmit}
                  className="customBtn"
                  disabled={loading}
                  // disabled={!isChecked}
                >
                  {dashboard.FatcaDeclaration.buttonText}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(
  ({ authReducer, investor }: RootStateType) => ({
    ...authReducer,
    ...investor,
  }),
  {
    getCountries,
    getFatcaDetails,
    updateFATCA,
  }
)(FatcaDeclaration);
